import { Executor, FromSchema } from '@40seas/entities/common';
import { Segment, SegmentEntity, WithSegmentBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CreditSafeReportData, CreditSafeReportDataSchema } from './credit-safe-report-data.entity';
import { CreditSafeReportShareCapital, CreditSafeReportShareCapitalSchema } from './credit-safe.shared-capital';
import { AiprizeBusinessScopeSchema, AiprizeRegistrationRecordSchema } from '@40seas/entities/aiprize';
import { AiprizeBusinessScope } from '@40seas/entities/aiprize';
import { AiprizeRegistrationRecord } from '@40seas/entities/aiprize';
import { CreditSafeVerifiedBusinessDetails, CreditSafeVerifiedBusinessDetailsSchema } from './credit-safe.verified-business-details';
import { CreditSafeInternationalScore, CreditSafeInternationalScoreSchema } from './credit-safe.internationalScore';
import { CreditSafeScore, CreditSafeScoreSchema } from './credit-safe.score.entity';
import { CreditSafeRecommendedCreditLimit, CreditSafeRecommendedCreditLimitSchema } from './credit-safe.recommanded-credit-limit';
import { CreditSafeReportRelatedCompany, CreditSafeReportRelatedCompanySchema } from '../credit-safe.report.related-company';
import { CreditSafeReportRelatedPerson, CreditSafeReportRelatedPersonSchema } from './credit-safe.report.related-person';

export const CreditSafeReportSchema = WithSegmentBaseEntitySchema(
    z.object({
        buyer: z.string(),
        companyId: z.string(),
        connectionId: z.string(),
        reportData: CreditSafeReportDataSchema.optional(),

        verifiedBusinessDetails: CreditSafeVerifiedBusinessDetailsSchema.optional(),
        relatedPersons: z.array(CreditSafeReportRelatedPersonSchema).optional(),
        relatedCompanies: z.array(CreditSafeReportRelatedCompanySchema).optional(),
        businessScope: AiprizeBusinessScopeSchema.optional(),
        registrationRecords: z.array(AiprizeRegistrationRecordSchema).optional(),
        creditScore: CreditSafeScoreSchema.optional(),
        internationalScore: CreditSafeInternationalScoreSchema.optional(),
        recommendedCreditLimit: CreditSafeRecommendedCreditLimitSchema.optional(),
        shareCapital: CreditSafeReportShareCapitalSchema.optional(),
        financialStatement: z.any().optional(),
        localFinancialStatement: z.any().optional(),

        rawData: z.any().optional(),
    }),
).strict();

export class CreditSafeReport extends FromSchema(CreditSafeReportSchema) implements SegmentEntity {
    id: string;
    buyer: string;

    companyId: string;
    connectionId: string;
    rawData?: any;
    reportData?: CreditSafeReportData;

    verifiedBusinessDetails?: CreditSafeVerifiedBusinessDetails;
    relatedPersons?: CreditSafeReportRelatedPerson[];
    relatedCompanies?: CreditSafeReportRelatedCompany[];
    businessScope?: AiprizeBusinessScope;
    registrationRecords?: AiprizeRegistrationRecord[];
    creditScore?: CreditSafeScore;
    internationalScore?: CreditSafeInternationalScore;
    recommendedCreditLimit?: CreditSafeRecommendedCreditLimit;
    shareCapital?: CreditSafeReportShareCapital;
    financialStatement?: any;
    localFinancialStatement?: any;

    tenantId: string;
    seller: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    segments?: Segment[];
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
